import React from 'react'
import createReactClass from 'create-react-class'
import _ from 'lodash'
import i18n from 'live/services/i18n'
import xhr from 'live/services/xhr'
import FormBase from 'live/components/extensions/ui/form'
import FormGroup from 'live/components/forms/ui/form-group'
import HandsonTable, {
    clearElement,
    isRowEmpty,
    getRequiredCellRenderer
} from 'plugin-liverig/shared/curves/handson-table'
import styled from 'styled-components'
import theme from 'live/services/theme'
import LiveTooltip from 'live/components/ui/tooltip'
import ReactDOM from 'react-dom'
import globalNotification from 'live/services/global-notification'

const TYPE = 'pwda-normalizer'
const CURVES_URL = '/services/plugin-liverig/curves'

function customColumnHeader(
    columnName: string,
    warningMessage: string,
    showWarning: boolean,
    icon = 'fas fa-exclamation-triangle text-danger'
) {
    const container = document.createElement('div')

    container.className = 'relative'
    ReactDOM.render(
        <span className="colHeader columnSorting">
            <div className="flex flex-1 flex-center-items">
                <span className="columnSorting flex-1">{columnName}</span>
                {showWarning ? (
                    <LiveTooltip content={warningMessage}>
                        <i className={icon} />
                    </LiveTooltip>
                ) : null}
            </div>
        </span>,
        container
    )

    return container
}

var ValidationMixin = require('live/components/forms/mixins/validation-mixin')
var ObjectInitializerMixin = require('live/components/forms/mixins/object-initializer')('/rest/extension', {
    type: 'liverig-' + TYPE,
    active: true,
    config: {
        eventType: '',
        configs: []
    },
    fullQualifier: '',
    qualifier: '',
    status: {}
})

var Form = createReactClass({
    mixins: [ObjectInitializerMixin, ValidationMixin],
    validations: {
        properties: {
            config: {
                properties: {
                    eventType: {
                        required: true,
                        allowEmpty: false,
                        message: i18n('Origin Event Type') + ' ' + i18n('must not be empty')
                    }
                }
            }
        }
    },
    UNSAFE_componentWillMount() {
        const descriptionsToMnemonics = {}
        const mnemonicsToDescriptions = {}
        const descriptions = []

        xhr.get(CURVES_URL).then(({ data }) => {
            _.map(data, (curve, mnemonic) => {
                const description = curve.description + ' (' + mnemonic + ')'

                descriptionsToMnemonics[description] = mnemonic
                mnemonicsToDescriptions[mnemonic] = description
                descriptions.push(description)
            })
            this.setState({ descriptionsToMnemonics, mnemonicsToDescriptions, descriptions })
        })

        this._submit = this.submit
    },
    addRow() {
        if (this.handsomeTable) this.handsomeTable.addRow()
    },
    _onSuccess: function() {
        window.location.href = '#/integrations/' + TYPE + '/' + this.state.object.id
    },
    _onDelete: function() {
        window.location.href = '#/integrations/'
    },
    makeUrl(baseUrl, id) {
        if (id) return baseUrl + '/' + id

        return baseUrl
    },
    submit(e) {
        let object = this.state.object
        const config = object.config.configs.filter(
            value => !(_.isEmpty(value.outputMnemonic) && _.isEmpty(value.inputMnemonic) && _.isEmpty(value.uom))
        )

        const newArray = config.filter(
            value =>
                !(
                    _.isEmpty(value.outputMnemonic) ||
                    _.isEmpty(value.inputMnemonic) ||
                    (!this.state.mnemonicsToDescriptions[value.outputMnemonic] &&
                        !this.state.descriptionsToMnemonics[value.outputMnemonic])
                )
        )

        if (config.length !== newArray.length) {
            globalNotification.error(
                i18n(
                    'Target channel must be a valid standart channel and target and input channels must not be empty on filled rows.'
                )
            )
            this.setState({ saving: false, saved: false })

            return false
        }

        for (const value of newArray) {
            if (this.state.descriptionsToMnemonics[value.outputMnemonic]) {
                value.outputMnemonic = this.state.descriptionsToMnemonics[value.outputMnemonic]
            }
        }

        object.config.configs = newArray
        this.applyObj(object)

        if (!this._forceValidation()) return
        this.setState({ saving: true })

        var id = this.props.id
        var fn = xhr.put

        if (!id || this.props.duplicate) {
            fn = xhr.post
            id = null

            if (typeof this.props.onBeforeDuplicateObject === 'function') {
                object = this.props.onBeforeDuplicateObject(object)
            }
        }

        const promise = fn(this.makeUrl('/rest/extension', id), object)

        return new Promise((resolve, reject) => {
            promise
                .then(resp => {
                    this.__onSuccess(resp)
                    resolve(resp)
                })
                .fail(resp => {
                    this.__onFail(resp)
                    reject(resp)
                })
        })
    },
    tableConfig: function() {
        return {
            viewportRowRenderingOffset: 1000,
            rowHeights: 29,
            manualColumnResize: true,
            manualRowMove: true,
            startCols: 3,
            minCols: 3,
            rowHeaders: () => '',
            get colHeaders() {
                return [i18n('Input Channel Name'), i18n('Target Channel Name'), i18n('Unit When Absent')]
            },
            getColwidths: (width: number) => {
                return [width * 0.35, width * 0.35, width * 0.3]
            },
            afterGetColHeader: function(col, th: HTMLElement) {
                const { showEmptyInputWarning, showEmptyTargetWarning } = this.getSettings()
                const firstChild = document.createElement('div')

                switch (col) {
                    case 0:
                        clearElement(th)
                        th.appendChild(firstChild)
                        firstChild.appendChild(
                            customColumnHeader(
                                i18n('Input Channel Name'),
                                i18n('All configurations must have a input'),
                                showEmptyInputWarning
                            )
                        )
                        break
                    case 1:
                        clearElement(th)
                        th.appendChild(firstChild)
                        firstChild.appendChild(
                            customColumnHeader(
                                i18n('Target Channel Name'),
                                i18n('All configurations must have a target'),
                                showEmptyTargetWarning
                            )
                        )
                        break
                    case 2:
                        clearElement(th)
                        th.appendChild(firstChild)
                        const container = document.createElement('div')

                        container.className = 'relative'
                        ReactDOM.render(
                            <span className="colHeader columnSorting">
                                <div className="flex flex-1 flex-center-items">
                                    <span className="columnSorting flex-1">{i18n('Unit When Absent')}&nbsp;</span>
                                    <LiveTooltip position="top" content={i18n('Default unit info')}>
                                        <StyledIcon className="far fa-question-circle" />
                                    </LiveTooltip>
                                </div>
                            </span>,
                            container
                        )
                        firstChild.appendChild(container)
                        break
                }

                return th
            },
            showEmptyTargetWarning: false,
            showEmptyInputWarning: false,
            beforeRender: function() {
                const settings = this.getSettings()

                settings.showEmptyTargetWarning = false
                settings.showEmptyInputWarning = false
            },
            contextMenu: ['row_above', 'row_below', 'remove_row', 'cut', 'copy', 'redo', 'undo'],
            columns: [
                {
                    data: 'inputMnemonic',
                    type: 'autocomplete',
                    strict: false,
                    trimDropdown: true,
                    source: [
                        'theoretical_ecd',
                        'theoretical_esd',
                        'theoretical_esd_non_solids',
                        'calculated_standpipe_pressure',
                        'real_hole_depth',
                        'real_bit_depth',
                        'bop_element',
                        'bop_element_status',
                        'steel_volume',
                        'torque_ema',
                        'solids_flow_out',
                        'calculated_shoe_ecd',
                        'drill_string_stretch',
                        'bit_rotary_speed',
                        'rate_of_penetration_average',
                        'mpd_step_size',
                        'mpd_volume'
                    ],
                    renderer: getRequiredCellRenderer(instance => {
                        instance.getSettings().showEmptyInputWarning = true
                    })
                },
                {
                    data: 'outputMnemonic',
                    type: 'autocomplete',
                    strict: false,
                    trimDropdown: true,
                    source: this.state.descriptions,
                    renderer: (instance, td, row, col, prop, value, cellProperties) => {
                        const callback = instance => {
                            instance.getSettings().showEmptyTargetWarning = true
                        }

                        td.innerHTML = value !== null && typeof value !== 'undefined' ? value : ''
                        const isEmpty = isRowEmpty(instance.getDataAtRow(row))

                        if (!isEmpty && _.isEmpty(value)) {
                            td.style.backgroundColor = '#f06d69'
                            td.title = i18n('Required field')
                            if (callback) callback(instance)
                        }

                        if (
                            !isEmpty &&
                            this.state.mnemonicsToDescriptions &&
                            this.state.mnemonicsToDescriptions[value]
                        ) {
                            td.innerHTML = this.state.mnemonicsToDescriptions[value]
                        }
                    }
                },
                {
                    data: 'uom',
                    type: 'text'
                }
            ]
        }
    },
    render: function() {
        var uiCfg = {
            hideDivider: true
        }

        const { object, mnemonicsToDescriptions, descriptionsToMnemonics } = this.state
        const config = object.config

        return (
            <FormBase self={this} uiCfg={uiCfg} test={false}>
                <div className={'export-form ' + TYPE}>
                    <div className="form-area">
                        <FormGroup
                            type="text"
                            label={i18n('Origin event Type')}
                            name="config.eventType"
                            value={config.eventType}
                            onChange={this.handleValidation}
                            validationState={this.validationState('config.eventType')}
                            hasFeedback
                            help={this.errorsFor('config.eventType')}
                        />
                    </div>
                </div>
                <div className="form-group">
                    <label>{i18n('Channels normalization')}</label>
                    <span className="help-block">
                        {i18n('Important: bop_element events will be normalized as bop_element - bop_element_status')}
                    </span>
                </div>
                <TableBody>
                    {!_.isEmpty(mnemonicsToDescriptions) && !_.isEmpty(descriptionsToMnemonics) ? (
                        <HandsonTable
                            ref={ref => (this.handsomeTable = ref)}
                            config={this.tableConfig()}
                            rows={config.configs}
                        />
                    ) : (
                        <StyledLoading>
                            <i className="fa fa-spin fa-spinner" /> {i18n('Loading...')}
                        </StyledLoading>
                    )}
                </TableBody>
                <AddRowButtonContainer>
                    <button onClick={this.addRow}>
                        <i className="far fa-plus" /> {i18n('ADD ROW')}
                    </button>
                </AddRowButtonContainer>
            </FormBase>
        )
    }
})

const StyledLoading = styled.p`
    color: ${theme['text-color']};
    font-size: 13px;
    margin: 0;
    min-width: 100%;
    padding: 20px 0;
    text-align: center;

    .fa-spin {
        margin-right: 5px;
    }
`
const StyledIcon = styled.i`
    color: ${theme['brand-primary']};
    font-size: 11px;
`
const TableBody = styled.div`
    && {
        display: flex;
        height: 500px;
        padding-bottom: 0;
        flex-direction: column;
    }
`

const AddRowButtonContainer = styled.div`
    display: flex;
    align-items: center;
    justify-content: center;
    height: 36px;
    margin-bottom: 32px;

    > button {
        background-color: #c3e3fa;
        display: flex;
        align-items: center;
        justify-content: center;
        height: 36px;
        width: 100%;
        color: #008ac7;
        font-family: ${theme['font-semibold']};
        border: 0;
        font-size: 13px;

        > i {
            margin-right: 5px;
        }
    }
`

module.exports = Form
